import React from "react";
import classNames from "classnames";
import { NavLink } from "react-router";
import { TabProps } from ".";

interface TabsProps {
  tabs: ReadonlyArray<TabProps>;
  url: string;
  className: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, url, className }: TabsProps): JSX.Element => {
  return (
    <div className={classNames("caprx-nav-tabs-list", className)}>
      {tabs.map(({ name, route }) => {
        return (
          <NavLink
            key={name}
            to={`${url}${route}`}
            style={{ textDecoration: "none" }}
            className={({ isActive }) => (isActive ? "caprx-nav-tab-active caprx-nav-tab" : "caprx-nav-tab")}
          >
            {name}
          </NavLink>
        );
      })}
    </div>
  );
};

export default Tabs;
